import router from '@/router';
import store from '@/store';

export default {
  returnPreviousPage(defaultPath = null) {
    const historyPages = store.state.page.historyPage;
    const previousPage = historyPages[historyPages.length - 1];
    if (!previousPage.name && defaultPath) {
      //上一頁來自於外部網站
      router.push(defaultPath);
    } else {
      //返回前一頁
      router.go(-1);
    }
  },
  setHistoryPage(page) {
    store.dispatch('page/setHistoryPage', page);
    store.dispatch('page/setPreviousPage', page);
  },
  getBackRoute({ type, from, modelId, query, factoryId, defaultUrl }) {
    if (query && query.redirect) {
      return query.redirect;
    }
    let url = defaultUrl;
    const _factoryId = factoryId ? factoryId : store.state.app.factoryId;
    if (from === 'alert') {
      if (modelId) {
        url = `/factory/${_factoryId}/alert-content/${modelId}`;
      } else {
        url = `/factory/${_factoryId}/alerts`;
      }
    } else if (from === 'board') {
      url = {
        path: `/factory/${_factoryId}/board-overview`,
        query: query,
      };
    } else if (from === 'contractor') {
      url = `/factory/${_factoryId}/contractor-content/${modelId}`;
    } else if (from === 'notification') {
      url = `/factory/${_factoryId}/notifications`;
    } else if (type === 'license') {
      if (from === 'index' && query.tab) {
        url = {
          path: `/factory/${_factoryId}/licenses`,
          query: query,
        };
      } else {
        url = `/factory/${_factoryId}/licenses`;
      }
    } else if (type === 'act') {
      if (from === 'index' && query.tab) {
        url = {
          path: `/factory/${_factoryId}/acts`,
          query: query,
        };
      } else {
        url = `/factory/${_factoryId}/acts`;
      }
    } else if (type === 'change') {
      if (from === 'index') {
        url = {
          path: `/factory/${_factoryId}/changes`,
          query: query,
        };
      }
    } else if (type === 'internal-training') {
      if (from === 'index') {
        url = {
          path: `/factory/${_factoryId}/trainings`,
          query: query,
        };
      }
      if (from === 'internalTrainingGroup') {
        url = {
          path: modelId ? `/factory/${_factoryId}/internal-training-group-content/${modelId}` : `/factory/${_factoryId}/trainings`,
          query: {
            ...query,
            tab: 'internalTrainingGroup',
          },
        };
      }
    } else if (type === 'audit-result') {
      if (from === 'index') {
        url = {
          path: `/factory/${_factoryId}/audits`,
          query: query,
        };
      }
    } else if (type === "checklist") {
      if (from === 'index') {
        url = {
          path: `/factory/${_factoryId}/checklists`,query,
        };
      }
      if (from === 'show') {
        url = {
          path: `/factory/${_factoryId}/checklist-content/${modelId}`,query,
        };
      }
      if (from === 'board') {
        url = {
          path: `/factory/${_factoryId}/board-overview`,query,
        };
      }
      if (from === 'alert') {
        url = {
          path: `/factory/${_factoryId}/alert-content/${modelId}`,query,
        };
      }
      if (from === 'recordList') {
        url = {
          path: `/factory/${_factoryId}/checklist/${modelId}/checklist-record-list`,query,
        };
      }
      if (from === 'assignmentIndex') {
        url = {
          path: `/factory/${_factoryId}/checklist/${modelId}/checklist-assignment-index`,query,
        };
      }
    } else if (type === 'agent') {
      if (from === 'show') {
        url = {
          path: `/factory/${_factoryId}/agent-content/${modelId}`,
          query: {tab: 'agent'},
        };
      } else {
        url = {
          path: `/factory/${_factoryId}/setting-main`,
          query: {tab: 'agent'},
        };
      }
    } else if (type === 'dashboard') {
      url = `/factory/${_factoryId}/dashboard-main`;
    } else if (type === 'commonChoiceGroup') {
      url = {
        path: `/factory/${_factoryId}/checklist-common-choice-group-content/${modelId}`,
        query,
      }
    } else if (type === 'guidelineAdmin') {
      if (from === 'index') {
        url = {
          path: `/factory/${_factoryId}/guideline-admins`,query,
        };
      } else if (from === 'show') {
        url = {
          path: `/factory/${_factoryId}/guideline-admin-content/${modelId}`,query,
        };
      } else {
        url = {
          path: `/factory/${_factoryId}/guideline-admins`,query,
        };
      }
    } else if (type === 'guideline') {
      if (from === 'index') {
        url = {
          path: `/factory/${_factoryId}/guidelines`,query,
        };
      }
    } else if (type === 'announcement') {
      if (from === 'index') {
        url = {
          path: `/factory/${_factoryId}/announcements`,query,
        };
      }
    } else if (type === 'meeting') {
      if (from === 'show') {
        url = {
          path: `/factory/${_factoryId}/meeting-content/${modelId}`,query,
        };
      } else if (from === 'batchUpdateGroup') {
        url = {
          path: `/factory/${_factoryId}/meeting-batch-update-group/${modelId}`,query,
        };
      } else {
        url = {
          path: `/factory/${_factoryId}/meetings`,query,
        };
      }
    } else if (type === 'meetingTemplate') {
      if (from === 'show') {
        url = {
          path: `/factory/${_factoryId}/meeting-template-content/${modelId}`,query,
        };
      }
    } else if (type === 'log') {
      url = {
        path: `/factory/${_factoryId}/logs`,query,
      };
    } else if (type === 'task') {
      if (from === 'index') {
        url = {
          path: `/factory/${_factoryId}/tasks`,query,
        };
      } else if (from === 'show') {
        url = {
          path: `/factory/${_factoryId}/task-content/${modelId}`,query,
        };
      }
    } else if (type === 'taskTemplate') {
      if (from === 'show') {
        url = {
          path: `/factory/${_factoryId}/task-template-content/${modelId}`,query,
        };
      }
    } else if (from === 'setting') {
      url = {
        path: `/factory/${_factoryId}/setting-main`,query,
      };
    }
    return url;
  },
};
